import { Route, Routes } from "react-router-dom";
import CarreraGovTech from "../newPages/carreras/CarreraGovTech";
import CarreraGovTechMetodologia from "../newPages/carreras/CarreraGovTechMetologia";
import CarreraEnergia from "../newPages/carreras/CarreraEnergia";

function RoutesCarreras() {
  return (
    <>
      <Routes>
        {" "}
        <Route
          path="/carrera-govtech-online"
          element={<CarreraGovTech></CarreraGovTech>}
        />
         <Route
          path="/metodologia-govtech"
          element={<CarreraGovTechMetodologia></CarreraGovTechMetodologia>}
        />
          {/* <Route
          path="/carrera-energia-online"
          element={<CarreraEnergia></CarreraEnergia>}
        /> */}
      </Routes>{" "}
    </>
  );
}

export default RoutesCarreras;
